import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAxios } from "src/helpers";

/** API call to retrieve all lookup data */
export const getAllLookupData = createAsyncThunk(
  "getAllLookupDataThunk",
  async (model, thunkAPI) => {
    try {
      let result = await getAxios().get("/Lookup/all");
      return result.data;
    } catch (error) {
      thunkAPI.rejectWithValue(error);
    }
  }
);
